/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black" :to="{ name: 'top'} ">
                        <p class="top_tit">TOPへ</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s"> </p>
                    <p class="menu_center_tex_l">衛生管理計画書画面</p>
                </div>
            </div>
        </div>
        <HygieneManagementPlan />
    </div>
</template>

<script>
    import HygieneManagementPlan from '@/app/components/HygieneManagementPlan.vue'
    export default {
        name: "ManageHygieneManagementPlan",
        components: {
            HygieneManagementPlan
        }
    }
</script> 